import {
  mobile,
  backend,
  web,
  bootstrap,
  firebase,
  reactjs,
  redux,
  tailwind,
  nodejs,
  android,
  mongodb,
  sql,
  gcp,
  aws,
  docker,
  python,
  // kubernetes,
  logo,
  utn,
  naranjax,
  afip,
  spotivote,
  firmax,
  bugui,
  nestjs,
  autotrady,
  abmproducts,
  songitgaming,
  utnfrba,
  gabypedidos,
  volsmart,
  phinxlab,
  chatia,
  cccabogadas,
  santander,
  shopy,
  turnosys,
  automotora,
} from "../assets";

import {
  diplomaUTN,
  diplomaUTNReverso,
  backendNestJs,
  nestJsAuth,
  nestJsMongo,
  nestJsModular,
  rutaNodeJs,
  reactJs,
  reactEcommerce,
  reactViteTailwind,
  reactRedux,
  arqAltaConcurrencia,
  arqSoftware,
  fundArqSoftware,
  cleanCode,
  jsEngine,
  flutter,
  flutterAvanzado,
  fastApi,
  claudeAI,
  fundLLMS,
  googleAds,
  googleAdsSearch,
  scrum,
  tokensEthereum,
  creacionEmpresas,
} from "../assets/certifications";

export const navLinks = [
  {
    id: "sobre-mi",
    title: "Sobre mí",
  },
  {
    id: "experiencia",
    title: "Experiencia",
  },
  {
    id: "certificaciones",
    title: "Certificaciones",
  },
  {
    id: "proyectos",
    title: "Proyectos",
  },
  {
    id: "contacto",
    title: "Contacto",
  },
];

const services = [
  {
    title: "Desarrollo de Aplicaciones Web",
    icon: web,
  },
  {
    title: "Desarrollo de Aplicaciones Móviles",
    icon: mobile,
  },
  {
    title: "Desarrollo de Inteligencia Artificial",
    icon: backend,
  },
];

const technologies = [
  {
    id: 1,
    name: "Node JS",
    icon: nodejs,
  },
  {
    id: 2,
    name: "Nest JS",
    icon: nestjs,
  },
  {
    id: 3,
    name: "React JS",
    icon: reactjs,
  },
  {
    id: 4,
    name: "Redux Toolkit",
    icon: redux,
  },
  {
    id: 5,
    name: "Tailwind",
    icon: tailwind,
  },
  {
    id: 6,
    name: "Bootstrap",
    icon: bootstrap,
  },
  {
    id: 7,
    name: "Kotlin y Flutter",
    icon: android,
  },
  {
    id: 8,
    name: "Python",
    icon: python,
  },
  {
    id: 9,
    name: "MongoDB",
    icon: mongodb,
  },
  {
    id: 10,
    name: "SQL",
    icon: sql,
  },
  {
    id: 11,
    name: "Firebase",
    icon: firebase,
  },
  {
    id: 12,
    name: "GCP",
    icon: gcp,
  },
  {
    id: 13,
    name: "AWS",
    icon: aws,
  },
  {
    id: 14,
    name: "Docker",
    icon: docker,
  },
];

const experiences = [
  {
    title: "Full Stack Engineer",
    company_name: "Cosemai",
    icon: logo,
    iconBg: "#E6DEDD",
    date: "Marzo de 2026 - Actualidad",
    points: [
      "Desarrollo de aplicaciones web y móviles a medida para startups y negocios.",
      "Diseño e implementación de arquitecturas Full Stack con React, Node.js, NestJS, Python, Kotlin, Flutter y bases de datos SQL/NoSQL.",
      "Gestión integral de proyectos: estrategia, relevamiento, desarrollo, despliegue y soporte en la nube (GCP, AWS, Firebase).",
    ],
  },
  {
    title: "Ingeniero Full Stack Sr.",
    company_name: "Banco Santander",
    icon: santander,
    iconBg: "#E6DEDD",
    date: "Octubre de 2025 - Marzo de 2026",
    points: [
      "Diseño y desarrollo Full Stack de microfrontends y microservicios del Sistema de Inversiones del Banco Santander.",
      "Desarrollo de microfrontends en React, TypeScript y Flame.",
      "Desarrollo de microservicios en Node.js con APIs REST, aplicando buenas prácticas de arquitectura y escalabilidad. Despliegue con Docker y gestión de la base de datos MongoDB.",
      "Trabajo colaborativo bajo la metodología SCRUM. Integración con microservicios internos y comunicación con otros equipos del Banco Santander.",
    ],
  },
  {
    title: "Ingeniero Full Stack Sr.",
    company_name: "Phinx Lab - Novatech",
    icon: phinxlab,
    iconBg: "#E6DEDD",
    date: "Octubre de 2024 - Octubre 2025",
    points: [
      "Desarrollo del sistema de gestión de turnos del Gobierno de la Ciudad de Buenos Aires.",
      "Desarrollo de API REST en entornos de microservicios utilizando tecnologías como Node.js con Express.",
      "Desarrollo de interfaces de usuario con ReactJS",
      "Gestión de bases de datos SQL y NoSQL.",
    ],
  },
  {
    title: "Ingeniero Full Stack",
    company_name: "Volsmart",
    icon: volsmart,
    iconBg: "#E6DEDD",
    date: "Mayo de 2024 - Octubre de 2024",
    points: [
      "Implementación del Sistema de Tokenización de activos en la blockchain usando React, Kotlin, Postgres, GraphQL y Kafka.",
      "Mantenimiento de Smart Contracts en Solidity.",
      "Implementación de contenedores Docker y despliegues en AWS.",
    ],
  },
  {
    title: "Desarrollador de Software",
    company_name: "Cosemai",
    icon: logo,
    iconBg: "#E6DEDD",
    date: "Abril de 2023 - Mayo de 2024",
    points: [
      "Desarrollo de interfaces de usuario con ReactJS, dinámicas y adaptables a todos los dispositivos mediante Bootstrap y Tailwind.",
      "Creación de API REST utilizando servicios en NodeJS con Express y NestJS.",
      "Desarrollo de aplicaciones móviles utilizando Kotlin y Dart con Flutter.",
      "Gestión de bases de datos Firebase, MongoDB y SQL.",
      "Gestión de infraestructura en Google Cloud Platform (GCP) y Amazon Web Services (AWS).",
    ],
  },
  {
    title: "Ingeniero de Software",
    company_name: "Naranja X",
    icon: naranjax,
    iconBg: "#E6DEDD",
    date: "Octubre de 2021 - Febrero de 2023",
    points: [
      "Desarrollo de API REST en entornos de microservicios utilizando tecnologías como Node.js con Express y NestJS.",
      "Implementación de contenedores Docker y despliegues en Kubernetes.",
      "Integración y utilización de servicios de AWS como: DynamoDB, RDS, SQS, SNS, S3, etc.",
    ],
  },
  {
    title: "Auditor de Sistemas de Información",
    company_name: "AFIP",
    icon: afip,
    iconBg: "#E6DEDD",
    date: "Octubre de 2019 - Octubre de 2021",
    points: [
      "Evaluación de riesgos y controles, detección de oportunidades de mejora, elaboración de informes operativos y ejecutivos y recomendaciones de auditoría.",
      "Colaboración con otras áreas para mejorar la protección de datos e infraestructura.",
      "Desarrollo en Python, Bash y PowerShell para la automatización de auditorías.",
    ],
  },
  {
    title: "Desarrollador de Software",
    company_name: "Cosemai",
    icon: logo,
    iconBg: "#E6DEDD",
    date: "Mayo de 2019 - Octubre de 2021",
    points: [
      "Desarrollo de interfaces de usuario con ReactJS. Webs dinámicas y adaptables a todos los dispositivos mediante Bootstrap y Materialize.",
      "Creación de API REST utilizando servicios en NodeJS con Express y Python.",
      "Desarrollo de aplicaciones móviles utilizando Kotlin y Dart con Flutter.",
      "Gestión de bases de datos SQL y NoSQL.",
      "Gestión de infraestructura en Google Cloud Platform (GCP) y Firebase.",
    ],
  },
  {
    title: "Analista y Desarrollador de Sistemas",
    company_name: "UTN Buenos Aires",
    icon: utn,
    iconBg: "#E6DEDD",
    date: "Julio de 2018 - Octubre de 2019",
    points: [
      "Análisis funcional de procesos de negocio.",
      "Desarrollo en Python, PHP, JavaScript, CSS y HTML.",
      "Desarrollo de scripts en Python para la automatización de procesos de infraestructura.",
      "Gestión de bases de datos MySQL y SQL Server.",
      "Virtualización de servidores Linux.",
    ],
  },
  {
    title: "Ingeniero en Sistemas de Información",
    company_name: "UTN FRBA - Buenos Aires, Argentina",
    icon: utn,
    iconBg: "#E6DEDD",
    date: "2013 - 2019",
    points: [
      "Título de grado: Ingeniero en Sistemas de Información.",
      "Universidad Tecnológica Nacional, Facultad Regional Buenos Aires (UTN FRBA).",
    ],
  },
];

const agencyExperiences = [
  {
    title: "Ingeniero Full Stack",
    company_name: "CosemAI",
    icon: logo,
    iconBg: "#E6DEDD",
    date: "Marzo de 2026 - Actualidad",
    points: [
      "Desarrollo de software a medida: apps web, apps móviles e inteligencia artificial. Gestión integral de proyectos: análisis, desarrollo, despliegue, soporte y publicidad (Google).",
    ],
  },
  {
    title: "Ingeniero Full Stack Sr.",
    company_name: "Banco Santander",
    icon: santander,
    iconBg: "#E6DEDD",
    date: "Octubre de 2025 - Marzo de 2026",
    points: [
      "Desarrollo y mantenimiento del Sistema de Inversiones del Banco Santander. Implementación escalable, eficiente y segura.",
    ],
  },
  {
    title: "Ingeniero Full Stack Sr.",
    company_name: "Phinx Lab - Novatech",
    icon: phinxlab,
    iconBg: "#E6DEDD",
    date: "Octubre de 2024 - Octubre de 2025",
    points: [
      "Diseño y desarrollo desde cero del Sistema de Gestión de Turnos e Inscripciones del Gobierno de la Ciudad de Buenos Aires.",
    ],
  },
  {
    title: "Ingeniero Full Stack",
    company_name: "Volsmart",
    icon: volsmart,
    iconBg: "#E6DEDD",
    date: "Mayo de 2024 - Octubre de 2024",
    points: [
      "Desarrollo e implementación del sistema de tokenización de activos inmobiliarios sobre Blockchain.",
    ],
  },
  {
    title: "Ingeniero Full Stack",
    company_name: "CosemAI",
    icon: logo,
    iconBg: "#E6DEDD",
    date: "Abril de 2023 - Mayo de 2024",
    points: [
      "Desarrollo de software a medida y gestión integral de proyectos.",
    ],
  },
  {
    title: "Ingeniero de Software Ssr.",
    company_name: "Naranja X",
    icon: naranjax,
    iconBg: "#E6DEDD",
    date: "Octubre de 2021 - Marzo de 2023",
    points: [
      "Desarrollo e implementación de microservicios para la fintech más importante de Argentina.",
    ],
  },
  {
    title: "Auditor de Sistemas de Información",
    company_name: "AFIP",
    icon: afip,
    iconBg: "#E6DEDD",
    date: "Octubre de 2019 - Octubre de 2021",
    points: [
      "Auditoría, seguridad de la información y evaluación de riesgos de sistemas. Automatización de procesos de auditoría.",
    ],
  },
  {
    title: "Analista y Desarrollador de Sistemas",
    company_name: "UTN Buenos Aires",
    icon: utn,
    iconBg: "#E6DEDD",
    date: "Octubre de 2017 - Octubre de 2019",
    points: [
      "Análisis funcional y desarrollo de los Sistemas de Gestión Académica. Automatización de procesos, soporte de apps y administración de bases de datos y servidores.",
    ],
  },
];

const certifications = [
  {
    title: "Ingeniero en Sistemas de Información",
    institution: "Universidad Tecnológica Nacional (UTN)",
    type: "degree",
    image: diplomaUTN,
    imageBack: diplomaUTNReverso,
    featured: true,
  },
  {
    title: "Backend con NestJS",
    institution: "Platzi",
    type: "certification",
    image: backendNestJs,
    featured: true,
  },
  {
    title: "Ruta de Backend con Node.js",
    institution: "Platzi",
    type: "certification",
    image: rutaNodeJs,
    featured: true,
  },
  {
    title: "React.js",
    institution: "Platzi",
    type: "certification",
    image: reactJs,
    featured: true,
  },
  {
    title: "NestJS: Autenticación con Passport y JWT",
    institution: "Platzi",
    type: "certification",
    image: nestJsAuth,
  },
  {
    title: "NestJS: Persistencia con MongoDB",
    institution: "Platzi",
    type: "certification",
    image: nestJsMongo,
  },
  {
    title: "NestJS: Programación Modular",
    institution: "Platzi",
    type: "certification",
    image: nestJsModular,
  },
  {
    title: "React.js con Vite y Tailwind",
    institution: "Platzi",
    type: "certification",
    image: reactViteTailwind,
  },
  {
    title: "React.js: E-commerce Profesional",
    institution: "Platzi",
    type: "certification",
    image: reactEcommerce,
  },
  {
    title: "React.js y Redux",
    institution: "Platzi",
    type: "certification",
    image: reactRedux,
    featured: true,
  },
  {
    title: "Arquitectura de Alta Concurrencia",
    institution: "Platzi",
    type: "certification",
    image: arqAltaConcurrencia,
  },
  {
    title: "Arquitectura de Software",
    institution: "Platzi",
    type: "certification",
    image: arqSoftware,
    featured: true,
  },
  {
    title: "Fundamentos de Arquitectura de Software",
    institution: "Platzi",
    type: "certification",
    image: fundArqSoftware,
  },
  {
    title: "Clean Code en JavaScript",
    institution: "Platzi",
    type: "certification",
    image: cleanCode,
  },
  {
    title: "JavaScript Engine y el Navegador",
    institution: "Platzi",
    type: "certification",
    image: jsEngine,
  },
  {
    title: "Flutter",
    institution: "Platzi",
    type: "certification",
    image: flutter,
  },
  {
    title: "Flutter Avanzado",
    institution: "Platzi",
    type: "certification",
    image: flutterAvanzado,
  },
  {
    title: "FastAPI",
    institution: "Platzi",
    type: "certification",
    image: fastApi,
  },
  {
    title: "Claude AI",
    institution: "Platzi",
    type: "certification",
    image: claudeAI,
  },
  {
    title: "Fundamentos de LLMs",
    institution: "Platzi",
    type: "certification",
    image: fundLLMS,
  },
  {
    title: "Google Ads",
    institution: "Platzi",
    type: "certification",
    image: googleAds,
  },
  {
    title: "Google Ads: Campañas de Búsqueda",
    institution: "Platzi",
    type: "certification",
    image: googleAdsSearch,
  },
  {
    title: "Scrum",
    institution: "Platzi",
    type: "certification",
    image: scrum,
  },
  {
    title: "Tokens en Ethereum",
    institution: "Platzi",
    type: "certification",
    image: tokensEthereum,
  },
  {
    title: "Creación de Empresas y Startups",
    institution: "Platzi",
    type: "certification",
    image: creacionEmpresas,
  },
];

const testimonials = [
  {
    testimonial: "",
    name: "",
    designation: "CFO",
    company: "Acme Co",
    image: "https://randomuser.me/api/portraits/women/4.jpg",
  },
  {
    testimonial: "",
    name: "",
    designation: "Diseñador gráfico",
    company: "UTN",
    image: "https://randomuser.me/api/portraits/men/5.jpg",
  },
  {
    testimonial: "",
    name: "",
    designation: "CTO",
    company: "456 Enterprises",
    image: "https://randomuser.me/api/portraits/women/6.jpg",
  },
];

const projects = [
  {
    name: "Automotora",
    description: "Web App - Gestión integral para concesionarias y automotoras",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "nodejs",
        color: "green-text-gradient",
      },
      {
        name: "firebase",
        color: "pink-text-gradient",
      },
    ],
    image: automotora,
    landingPath: "/sistema-para-automotoras",
  },
  {
    name: "TurnoSys",
    description: "Web App - Sistema de gestión de turnos online",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "nodejs",
        color: "green-text-gradient",
      },
      {
        name: "firebase",
        color: "pink-text-gradient",
      },
    ],
    image: turnosys,
  },
  {
    name: "ChatIA",
    description: "Web App - Chatbot IA para consultas dinámicas de datos en tiempo real",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "python",
        color: "green-text-gradient",
      },
      {
        name: "llm",
        color: "pink-text-gradient",
      },
    ],
    image: chatia,
  },
  {
    name: "AutoTrady",
    description: "Web App - Trading Automático",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "nodejs",
        color: "green-text-gradient",
      },
      {
        name: "firebase",
        color: "pink-text-gradient",
      },
    ],
    image: autotrady,
  },
  {
    name: "SpotiVote",
    description: "Mobile App - Votación de canciones",
    tags: [
      {
        name: "kotlin",
        color: "blue-text-gradient",
      },
      {
        name: "nestjs",
        color: "green-text-gradient",
      },
      {
        name: "mongodb",
        color: "pink-text-gradient",
      },
    ],
    image: spotivote,
  },
  {
    name: "Bugui",
    description: "Mobile App - Pedidos Online",
    tags: [
      {
        name: "flutter",
        color: "blue-text-gradient",
      },
      {
        name: "nodejs",
        color: "green-text-gradient",
      },
      {
        name: "firebase",
        color: "pink-text-gradient",
      },
    ],
    image: bugui,
  },
  {
    name: "Shopy",
    description: "E-commerce - Tienda online",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "nestjs",
        color: "green-text-gradient",
      },
      {
        name: "aws",
        color: "pink-text-gradient",
      },
    ],
    image: shopy,
  },
  {
    name: "Firmax",
    description: "Web App - Servicios financieros",
    tags: [
      {
        name: "bootstrap",
        color: "blue-text-gradient",
      },
      {
        name: "javascript",
        color: "green-text-gradient",
      },
      {
        name: "mysql",
        color: "pink-text-gradient",
      },
    ],
    image: firmax,
  },
  {
    name: "App de Delivery",
    description: "E-commerce - Sistema de pedidos online",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "nestjs",
        color: "green-text-gradient",
      },
      {
        name: "aws",
        color: "pink-text-gradient",
      },
    ],
    image: gabypedidos,
  },
];

export { services, technologies, experiences, agencyExperiences, certifications, testimonials, projects };
